module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__panel-simple"
  }, [_c('div', {
    staticClass: "__panel-simple__panel"
  }, [_c('button', {
    staticClass: "__panel-simple__close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('close')
      }
    }
  }), _c('div', {
    staticClass: "__panel-simple__inner"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa41e642","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/Simple.vue
// module id = 4c131a877fdd2409576e
// module chunks = 0